<button class="round-button" (click)="info()"><span class="round-button__icon icon icon-info-svgrepo-com"></span></button>

<app-modal id="modal-tip" width="640" [blocking]="true" #mt>
    <div class="tip-text" [innerHtml]="tipRef | translate"></div>

    <div class="modal__buttons">
        <button class="button button--square" (click)='mt.close()'>
        <span>{{ 'btn_ok' | translate }}</span>
        </button>
    </div>
</app-modal>
  